import { PerformanceCommentCategory } from '../../types/app/performanceComment.types';

import { api } from '../core/api';

export const getList = (parentId?: number) =>
  api
    .get<PerformanceCommentCategory[]>(`PerformanceCommentCategory/GetList?parentId=${parentId}`)
    .then((res) => res.data);
